import { formatDate, registerLocaleData } from '@angular/common';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, throwError } from 'rxjs';
import { Constants } from 'src/app/shared/constants/Constants';
import { IDemand } from 'src/app/shared/models/demand';
import { Echeance } from 'src/app/shared/models/echeance';
import { EcheanceStatus } from 'src/app/shared/models/echeance-status';
import { IManualData } from 'src/app/shared/models/manual-data';
import { IOrderForm } from 'src/app/shared/models/order-form';
import { IPack } from 'src/app/shared/models/pack';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { CommentBoxComponent } from '../dialog-box/comment-box.component';
import { CommentPromptComponent } from '../dialog-box/comment-prompt.component';
import { EcheancesService } from '../services/echeances.service';
import localeFr from '@angular/common/locales/fr';
import { SimplePromptComponent } from 'src/app/shared/simple-prompt/simple-prompt.component';
import { DialogFormNettingComponent } from 'src/app/shared/dialog-form-netting/dialog-form-netting/dialog-form-netting.component';
import { DialogFormNettingService } from 'src/app/shared/dialog-form-netting/dialog-form-netting.service';
import { UserProfile } from 'src/app/shared/models/user-profile';
import { AlertLevel, AlertVue, IAlert } from 'src/app/shared/models/alert';
import { DialogFormAlertComponent } from 'src/app/shared/dialog-form-alert/dialog-form-alert.component';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { SnackbarService } from '../../../../shared/services/snackbar.service';
import { DemandStatut, DemandStatusUpdateDTO } from 'src/app/shared/models/demand-status';
import { DemandStatusService } from 'src/app/shared/services/demand-status.service';
import { AuditLog } from 'src/app/shared/models/AuditLog';
import { DemandHistoryComponent } from './demand-history/demand-history.component';

registerLocaleData(localeFr);

@Component({
  selector: 'app-echeance-details',
  templateUrl: './echeance-details.component.html',
  styleUrls: ['./echeance-details.component.less']
})
export class EcheanceDetailsComponent {

  listInvoice: string[] = ['Par défaut'];

  public formGroup: UntypedFormGroup;

  public editingLoadValue: number = 0;
  public editingCostValue: number = 0;

  public isEditingRef          = false;
  public isEditingLoad         = false;
  public isEditingCost         = false;
  public isEditingManualData   = false;
  public isLoading             = true;

  public demand!: IDemand;
  public manualData!: IManualData;
  public currPack: IPack = new IPack();
  public targetAdminEcheanceStatus!: EcheanceStatus;
  public orderForms!: IOrderForm[];
  public isAlreadyValidating   = false;
  public statutMotifRefus = '';

  @Output() updateValidationCapability = new EventEmitter<boolean>();
  @Output() updateRejectionCapability  = new EventEmitter<boolean>();
  @Output() refreshTable: EventEmitter<boolean> = new EventEmitter();

  unreadCommentsNbr = 0;

  MONTHS: string[] = [
    'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
    'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
  ];

  statusColor  = '';
  validatable  = false;
  asyncLock    = true;
  nettingName  = 'Aucun';

  public isEditingStatus      = false;
  public transitionsPossibles: DemandStatut[] = [];
  public targetStatut!: DemandStatut;
  public statutCommentaire    = '';

  rowindex = 0;
  rowmin   = 0;
  rowmax   = 0;
  centreCompetenceMode = false;

  alerts: IAlert[] = [];
  alertLevel = 0;
  debugModeActivated = false;

  get EcheanceStatus() { return EcheanceStatus; }
  get Constants()      { return Constants; }
  get Object()         { return Object; }

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dialogRef: MatDialogRef<EcheanceDetailsComponent>,
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    private echeancesService: EcheancesService,
    private formBuilder: UntypedFormBuilder,
    public authenticationService: AuthenticationService,
    public demandStatusService: DemandStatusService,
    public theme: ThemeService,
    public _ns: DialogFormNettingService
  ) {
    this.formGroup = this.formBuilder.group({
      realFirstDate: '', realSecondDate: '', realThirdDate: '',
      estimateFirstDate: '', estimateSecondDate: '', estimateThirdDate: '',
      mDComment: '', invoiceType: '', reduction: 0
    });

    if (dialogData && dialogData.data) {
      this.rowindex            = this.dialogData['index'];
      this.rowmin              = this.dialogData['min'];
      this.rowmax              = this.dialogData['max'];
      this.validatable         = this.dialogData['validatable'];
      this.currPack.packMonth  = this.dialogData['month'];
      this.currPack.packYear   = this.dialogData['year'];
      this.centreCompetenceMode = this.dialogData['centreCompetenceMode'];
      this.initDialog();
    }

    this.debugModeActivated = this.authenticationService.getDebugMode();
  }

  // ── Initialisation ────────────────────────────────────────────────────────

  initDialog() {
    this.echeancesService.getAllowedFavturationTypes().subscribe({
      next: value => { this.listInvoice = value; }
    });

    this.demand = this.dialogData['data'][this.rowindex];

    if (this.debugModeActivated) {
      console.log('******** Mode débogage actif ********');
      console.log('Contenu de la demande:', this.demand);
      console.log('*************************************');
    }

    this.alerts              = [];
    this.isEditingManualData = false;

    if (this.demand.realizationDateTime != null) {
      this.demand.realizationDate = new Date(this.demand.realizationDateTime);
    }

    this.formGroup = this.formBuilder.group({
      realFirstDate: '', realSecondDate: '', realThirdDate: '',
      estimateFirstDate: '', estimateSecondDate: '', estimateThirdDate: '',
      mDComment: '', invoiceType: '', reduction: 0
    });

    this.nettingName = '';
    if (!this.authenticationService.isUserAdmin()) this.formGroup.disable();

    if (this.demand?.demandNumber) {
      this.echeancesService.getDemandManualData(this.demand).subscribe({
        next: data => {
          this.isLoading  = false;
          this.manualData = data;
          this.formGroup.setValue({
            realFirstDate:      this.manualData.realFirstDate      != null ? formatDate(this.manualData.realFirstDate + '', 'yyyy-MM-dd', 'en') : null,
            realSecondDate:     this.manualData.realSecondDate     != null ? formatDate(this.manualData.realSecondDate + '', 'yyyy-MM-dd', 'en') : null,
            realThirdDate:      this.manualData.realThirdDate      != null ? formatDate(this.manualData.realThirdDate + '', 'yyyy-MM-dd', 'en') : null,
            estimateFirstDate:  this.manualData.estimateFirstDate  != null ? formatDate(this.manualData.estimateFirstDate + '', 'yyyy-MM-dd', 'en') : null,
            estimateSecondDate: this.manualData.estimateSecondDate != null ? formatDate(this.manualData.estimateSecondDate + '', 'yyyy-MM-dd', 'en') : null,
            estimateThirdDate:  this.manualData.estimateThirdDate  != null ? formatDate(this.manualData.estimateThirdDate + '', 'yyyy-MM-dd', 'en') : null,
            mDComment:   this.manualData.comment,
            invoiceType: this.manualData.invoiceType,
            reduction:   this.manualData.reduction
          });
          this.isEditingManualData = this.manualData.demand != null;
          this.manualData.demand   = this.demand.demandNumber;
        },
        error: err => { console.log(err); }
      });
    }

    this._ns.getNettingFromDemand(this.demand).subscribe({
      next:  value => { this.nettingName = value != null ? value.name + '' : 'Aucun'; },
      error: err   => { console.error(err); }
    });

    this.alertLevel = 0;
    this.echeancesService.getDemandAlerts(this.demand).subscribe({
      next:  value => { this.alerts = value; this.handleAlerts(); },
      error: err   => { console.error(err); }
    });

    this.demand.echeances.sort(this.compareDues);
  }

  handleAlerts() {
    const temp: IAlert[] = [];
    this.alerts.forEach(e => {
      switch (this.authenticationService.getUser().profile) {
        case UserProfile.CP_CDS:
        case UserProfile.GUEST_CDS:
          if (e.type == AlertVue.BEB || e.type == AlertVue.CDS || e.type == AlertVue.DSI) temp.push(e);
          break;
        case UserProfile.CP_SNCF:
        case UserProfile.GUEST_SNCF:
        case UserProfile.SERVICE_MANAGER:
          if (e.type == AlertVue.DSI) temp.push(e);
          break;
        default:
          temp.push(e);
      }
    });
    temp.forEach(e => {
      switch (e.severity) {
        case AlertLevel.Majeur:
        case AlertLevel.Bloquant:      if (this.alertLevel < 3) this.alertLevel = 3; break;
        case AlertLevel.Avertissement: if (this.alertLevel < 2) this.alertLevel = 2; break;
        case AlertLevel.Information:   if (this.alertLevel < 1) this.alertLevel = 1; break;
      }
    });
    this.alerts = temp;
  }

  isManualDataNull(): boolean {
    if (this.manualData.comment      && this.manualData.comment      !== '') return true;
    if (this.manualData.invoiceType  && this.manualData.invoiceType  !== '') return true;
    if (this.manualData.reduction    && this.manualData.reduction    !== 0)  return true;
    if (this.manualData.realFirstDate      != null) return true;
    if (this.manualData.realSecondDate     != null) return true;
    if (this.manualData.realThirdDate      != null) return true;
    if (this.manualData.estimateFirstDate  != null) return true;
    if (this.manualData.estimateSecondDate != null) return true;
    if (this.manualData.estimateThirdDate  != null) return true;
    return false;
  }

  // ── Navigation ────────────────────────────────────────────────────────────

  next() { this.rowindex++; this.isLoading = true; this.asyncLock = true; this.isAlreadyValidating = false; this.initDialog(); }
  prev() { this.rowindex--; this.isLoading = true; this.asyncLock = true; this.isAlreadyValidating = false; this.initDialog(); }

  // ── Suppression ───────────────────────────────────────────────────────────

  deleteSelf() {
    const dialogRef = this.dialog.open(SimplePromptComponent, {
      data: { message: 'Voulez vous vraiment supprimer la demande ' + this.demand.demandNumber + ' ?' }
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result) {
          this.echeancesService.deleteDemand(this.demand).subscribe({
            next: response => {
              if (response == null) {
                this.openSuccessSnackBar('La demande a été supprimée avec succès.');
                this.dialogRef.close();
                this.refreshTable.emit(true);
              } else {
                this.openErrorSnackBar("ERREUR: La demande n'a pas pu être supprimée.");
              }
            },
            error: err => { console.error(err); }
          });
        }
      },
      error: err => { console.error(err); }
    });
  }

  // ── Netting ───────────────────────────────────────────────────────────────

  dialogNetting() {
    this.demand.netting = this.nettingName.replace('Aucun', '');
    const dialogRef = this.dialog.open(DialogFormNettingComponent, {
      panelClass: 'confirm-dialog-container', disableClose: true, data: this.demand
    });
    dialogRef.afterClosed().subscribe({
      next: () => {
        this._ns.getNettingFromDemand(this.demand).subscribe({
          next: value => { this.nettingName = value != null ? value.name + '' : 'Aucun'; },
          error: err  => { console.error(err); }
        });
      },
      error: err => { console.error(err); }
    });
  }

  // ── Édition référence ─────────────────────────────────────────────────────

  toggleRef() {
    if (this.isEditingRef) {
      this.isEditingRef = false;
      this.isLoading = true;
      this.echeancesService.updateDemandRef(this.demand.demandNumber, this.demand.reference!).subscribe({
        next: () => {
          this.echeancesService.getDemand(this.demand.demandNumber).subscribe({
            next: demandValue => {
              this.isLoading = false;
              this.demand.reference    = demandValue.reference;
              this.isEditingManualData = this.isManualDataNull();
              this.refreshTable.emit(true);
            },
            error: err => { this.isLoading = false; throwError('Erreur mise à jour référence: ' + err); }
          });
        },
        error: err => { this.isLoading = false; console.log(err); }
      });
    } else {
      this.isEditingRef = true;
    }
  }

  // ── Édition charge ────────────────────────────────────────────────────────

  toggleLoad() {
    if (this.isEditingLoad) {
      this.isEditingLoad = false;
      this.isLoading = true;
      this.echeancesService.updateDemandLoad(this.demand.demandNumber, this.editingLoadValue).subscribe({
        next: () => {
          this.echeancesService.getDemand(this.demand.demandNumber).subscribe({
            next: demandValue => {
              this.isLoading = false;
              this.demand.load         = demandValue.load;
              this.isEditingManualData = this.isManualDataNull();
              this.refreshTable.emit(true);
            },
            error: err => { this.isLoading = false; throwError('Erreur mise à jour charge: ' + err); }
          });
        },
        error: err => { this.isLoading = false; console.log(err); }
      });
    } else {
      this.editingLoadValue = this.demand.load;
      this.isEditingLoad = true;
    }
  }

  // ── Édition montant ───────────────────────────────────────────────────────

  toggleCost() {
    if (this.isEditingCost) {
      this.isEditingCost = false;
      this.isLoading = true;
      this.echeancesService.updateDemandCost(this.demand.demandNumber, this.editingCostValue).subscribe({
        next: () => {
          this.echeancesService.getDemand(this.demand.demandNumber).subscribe({
            next: demandValue => {
              this.isLoading = false;
              this.demand.cost         = demandValue.cost;
              this.isEditingManualData = this.isManualDataNull();
              this.refreshTable.emit(true);
            },
            error: err => { this.isLoading = false; throwError('Erreur mise à jour montant: ' + err); }
          });
        },
        error: err => { this.isLoading = false; console.log(err); }
      });
    } else {
      this.editingCostValue = this.demand.cost;
      this.isEditingCost = true;
    }
  }

  onRefChange(evt: any)  { this.demand.reference = (evt.target as HTMLInputElement).value; }
  onLoadChange(evt: any) { this.demand.load = Number((evt.target as HTMLInputElement).value); }
  onCostChange(evt: any) { this.demand.cost = Number((evt.target as HTMLInputElement).value); }

  // ── Données manuelles ─────────────────────────────────────────────────────

  toggleEditing() { this.isEditingManualData = true; }

  cancelEditing() {
    if (!this.demand?.demandNumber) return;
    this.echeancesService.getDemandManualData(this.demand).subscribe({
      next: data => {
        this.manualData = data;
        this.formGroup.setValue({
          realFirstDate:      data.realFirstDate      != null ? formatDate(data.realFirstDate + '', 'yyyy-MM-dd', 'en') : null,
          realSecondDate:     data.realSecondDate     != null ? formatDate(data.realSecondDate + '', 'yyyy-MM-dd', 'en') : null,
          realThirdDate:      data.realThirdDate      != null ? formatDate(data.realThirdDate + '', 'yyyy-MM-dd', 'en') : null,
          estimateFirstDate:  data.estimateFirstDate  != null ? formatDate(data.estimateFirstDate + '', 'yyyy-MM-dd', 'en') : null,
          estimateSecondDate: data.estimateSecondDate != null ? formatDate(data.estimateSecondDate + '', 'yyyy-MM-dd', 'en') : null,
          estimateThirdDate:  data.estimateThirdDate  != null ? formatDate(data.estimateThirdDate + '', 'yyyy-MM-dd', 'en') : null,
          mDComment: data.comment, invoiceType: data.invoiceType, reduction: data.reduction
        });
        this.isLoading = false;
      },
      error: err => { console.log(err); }
    });
  }

  confirmEditing() {
    this.isLoading = true;
    const v = this.formGroup.value;
    this.manualData.realFirstDate      = v.realFirstDate      == null ? undefined : new Date(v.realFirstDate);
    this.manualData.realSecondDate     = v.realSecondDate     == null ? undefined : new Date(v.realSecondDate);
    this.manualData.realThirdDate      = v.realThirdDate      == null ? undefined : new Date(v.realThirdDate);
    this.manualData.estimateFirstDate  = v.estimateFirstDate  == null ? undefined : new Date(v.estimateFirstDate);
    this.manualData.estimateSecondDate = v.estimateSecondDate == null ? undefined : new Date(v.estimateSecondDate);
    this.manualData.estimateThirdDate  = v.estimateThirdDate  == null ? undefined : new Date(v.estimateThirdDate);
    this.manualData.reduction   = v.reduction ?? 0;
    this.manualData.invoiceType = v.invoiceType === 'Par défaut' ? '' : v.invoiceType;
    this.manualData.comment     = v.mDComment;

    this.echeancesService.postDemandManualData(this.manualData).subscribe({
      next: () => {
        this.echeancesService.getCalculDue(this.demand.demandNumber).subscribe({
          next: () => {
            this.echeancesService.getDemand(this.demand.demandNumber).subscribe({
              next: demandValue => {
                this.isLoading = false;
                this.demand.echeances    = demandValue.echeances;
                this.isEditingManualData = this.isManualDataNull();
                if (this.demand.echeances) this.demand.echeances.sort(this.compareDues);
                this.refreshTable.emit(true);
              },
              error: err => { this.isLoading = false; throwError('Erreur mise à jour données: ' + err); }
            });
          },
          error: err => { this.isLoading = false; throwError('Erreur facturation: ' + err); }
        });
      },
      error: err => { this.isLoading = false; throwError('Erreur données manuelles: ' + err); }
    });
  }

  // ── Statut ────────────────────────────────────────────────────────────────

  toggleStatus(): void {
    if (this.isEditingStatus) {
      this.isEditingStatus      = false;
      this.transitionsPossibles = [];
      this.statutCommentaire    = '';
      this.statutMotifRefus     = '';  // ← ajoute
      this.targetStatut         = null!;
      return;
    }

    this.demandStatusService.getAuditHistory('DEMAND', this.demand.demandNumber || '').subscribe({
      next: (historique: AuditLog[]) => {
        const currentStatut = this.demandStatusService.fromBackendStatut(this.demand.state || '');
        const transitions   = this.demandStatusService.getTransitionsPossibles(currentStatut, historique);
        this.transitionsPossibles = this.filterTransitionsByRole(transitions, currentStatut);
        this.isEditingStatus = true;
      },
      error: () => { this.openErrorSnackBar('Erreur lors du chargement des transitions'); }
    });
  }

  confirmStatusChange(): void {
    if (!this.targetStatut) return;

    // ── Validation côté front avant envoi ─────────────────────────────────
    const currentStatut = this.demandStatusService.fromBackendStatut(this.demand.state || '');
    const erreurEcheances = this.demandStatusService.validerTransitionEcheances(
      currentStatut,
      this.targetStatut,
      this.demand.echeances ?? []
    );
    if (erreurEcheances) {
      this.openErrorSnackBar(erreurEcheances);
      return;
    }

    const dto: DemandStatusUpdateDTO = {
      nouveauStatut: this.targetStatut,
      motifRetour:   this.statutCommentaire || undefined,
      motifRefus:    this.statutMotifRefus  || undefined
    };

    this.isLoading = true;
    this.demandStatusService.updateStatus(this.demand.demandNumber || '', dto).subscribe({
      next: (updatedDemand) => {
        this.isLoading         = false;
        this.demand.state      = updatedDemand.state;
        this.isEditingStatus   = false;
        this.targetStatut      = null!;
        this.statutCommentaire = '';
        this.statutMotifRefus  = '';
        this.refreshTable.emit(true);
        this.openSuccessSnackBar('Statut mis à jour avec succès');
      },
      error: (errFn) => {
        const err = typeof errFn === 'function' ? errFn() : errFn;
        this.isLoading = false;
        this.openErrorSnackBar(err?.error?.message ?? 'Erreur lors de la mise à jour du statut');
      }
    });
  }

  isMotifObligatoire(): boolean {
    if (!this.targetStatut) return false;
    const current = this.demandStatusService.fromBackendStatut(this.demand.state || '');
    return (current === DemandStatut.CHIFFRE || current === DemandStatut.ENGAGE)
      && this.targetStatut === DemandStatut.EN_ATTENTE;
  }

  openHistory(): void {
    this.dialog.open(DemandHistoryComponent, {
      data:       { demandNumber: this.demand.demandNumber },
      width:      '800px',
      maxWidth:   '95vw',
      panelClass: 'history-dialog-panel',
      autoFocus:  false
    });
  }

  // ── Filtrage transitions par rôle + règles échéances ─────────────────────

  filterTransitionsByRole(
    transitions: DemandStatut[],
    currentStatut: DemandStatut
  ): DemandStatut[] {
    const profile = this.authenticationService.getUser()?.profile;

    return transitions.filter(nextStatut => {
      if (!profile) return false;

      // Admin → tout autorisé (les règles échéances restent actives côté backend)
      if (this.isAdmin(profile)) return true;

      // ── Règles par rôle ──────────────────────────────────────────────────
      if (this.isSncfRole(profile)) {
        if (currentStatut === DemandStatut.CHIFFRE && nextStatut === DemandStatut.ENGAGE)     return true;
        if (nextStatut === DemandStatut.ANNULE)                                               return true;
        if (nextStatut === DemandStatut.EN_ATTENTE)                                           return true;
        return false;
      }

      if (this.isCdsRole(profile)) {
        console.log("Règles CDS: currentStatut=", currentStatut, "nextStatut=", nextStatut);
        if (currentStatut === DemandStatut.ENGAGE    && nextStatut === DemandStatut.LIVRE)    return true;
        if (currentStatut === DemandStatut.CHIFFRE    && nextStatut === DemandStatut.EN_ATTENTE)    return true;
        if (currentStatut === DemandStatut.CHIFFRE    && nextStatut === DemandStatut.ANNULE)    return true;
        if (currentStatut === DemandStatut.LIVRE     && nextStatut === DemandStatut.FERME)    return true;
        if (currentStatut === DemandStatut.EN_ATTENTE && nextStatut === DemandStatut.CHIFFRE) return true;

        return false;
      }

      return false;
    });
  }

  // ── Helpers rôles ─────────────────────────────────────────────────────────

  getUserRole(): string { return this.authenticationService.getUser()?.profile || ''; }

  isSncfRole(profile: string): boolean {
    return [UserProfile.CP_SNCF, UserProfile.GUEST_SNCF].includes(profile as UserProfile);
  }

  isCdsRole(profile: string): boolean {
    return [
      UserProfile.CP_CDS, UserProfile.MANAGER_CDS,
      UserProfile.GUEST_CDS, UserProfile.SERVICE_MANAGER
    ].includes(profile as UserProfile);
  }

  isAdmin(profile: string): boolean { return profile === UserProfile.ADMIN; }

  getStatutLabel(statut: string): string {
    const labels: Record<string, string> = {
      CHIFFRE: 'Chiffré', ENGAGE_APPROUVE: 'Engagé / Approuvé',
      EN_ATTENTE: 'En attente', LIVRE: 'Livré', FERME: 'Fermé', ANNULE: 'Annulé'
    };
    return labels[statut] ?? statut;
  }

  getStatutColor(statut: string): string {
    const colors: Record<string, string> = {
      CHIFFRE: '#1565C0', ENGAGE_APPROUVE: '#1565C0',
      EN_ATTENTE: '#616161', LIVRE: '#2E7D32', FERME: '#2E7D32', ANNULE: '#E64A19'
    };
    return colors[statut] ?? '#000';
  }

  // ── Alertes ───────────────────────────────────────────────────────────────

  dialogAlert() {
    this.dialog.open(DialogFormAlertComponent, { data: this.alerts });
  }

  // ── Commentaires ──────────────────────────────────────────────────────────

  public openDialog() {
    const matDialogRef = this.dialog.open(CommentBoxComponent, { id: 'comment-box' });
    matDialogRef.componentInstance.demand = this.demand;
    if (this.demand.demandNumber) {
      this.echeancesService.getComments(this.demand.demandNumber).subscribe({
        next: response => {
          if (response instanceof Array) {
            matDialogRef.componentInstance.demand.comments = response;
            matDialogRef.componentInstance.commentsDiv.nativeElement.scrollTop =
              matDialogRef.componentInstance.commentsDiv.nativeElement.scrollHeight;
          }
        },
        error: err => { console.error(err); }
      });
    }
    matDialogRef.afterClosed().subscribe({
      next: () => { this.demand.echeances.sort(this.compareDues); },
      error: err => { console.error(err); }
    });
  }

  openCommentPrompt(): MatDialogRef<CommentPromptComponent, any> {
    return this.dialog.open(CommentPromptComponent, {});
  }

  // ── Validation / Rejet ────────────────────────────────────────────────────

  public validateDemand() {
    if (this.demand.serviceType === 'A renseigner') {
      this.openErrorSnackBar('Veuillez renseigner le service de la demande avant de la valider.');
      return;
    }
    if (this.isAlreadyValidating || this.nettingName === '') return;
    this.isAlreadyValidating = true;

    const isCdsMgr = this.authenticationService.getUser().profile === UserProfile.CP_CDS
      || this.authenticationService.getUser().profile === UserProfile.MANAGER_CDS;

    if (isCdsMgr && this.nettingName === 'Aucun') {
      this.demand.netting = '';
      const dialogRef = this.dialog.open(DialogFormNettingComponent, {
        panelClass: 'confirm-dialog-container', disableClose: true, data: this.demand
      });
      dialogRef.afterClosed().subscribe({
        next: value => {
          if (value) {
            this._ns.getNettingFromDemand(this.demand).subscribe({
              next: v => { this.nettingName = v != null ? v.name + '' : 'Aucun'; },
              error: err => { console.error(err); }
            });
            this._doValidate();
          }
        },
        error: err => { console.error(err); }
      });
    } else {
      this._doValidate();
    }
  }

  private _doValidate() {
    this.echeancesService.validateDemands([this.demand.demandNumber]).subscribe({
      next: data => {
        if (data?.error) {
          console.error(data.error);
          this.isAlreadyValidating = false;
          this.openErrorSnackBar(
            data.demandsNumbersInError?.length
              ? Constants.ErrorMessages.DEMAND_NOT_VALIDATED + data.demandsNumbersInError
              : Constants.ErrorMessages.SERVER_TECH_ERROR
          );
        } else if (data.updatedDemands?.length) {
          this.openSuccessSnackBar(Constants.Messages.DEMAND_VALIDATED);
          this.demand.echeances = data.updatedDemands[0].echeances;
          this.demand.echeances.sort(this.compareDues);
          this.echeancesService.checkIfDemandValidableARRejectable(this.demand);
          this.isAlreadyValidating = false;
        }
        this.asyncLock = false;
      },
      error: err => { console.error(err); this.isAlreadyValidating = false; this.asyncLock = false; }
    });
  }

  public rejectDemand() {
    if (this.isAlreadyValidating) return;
    this.isAlreadyValidating = true;
    this.openCommentPrompt().afterClosed().subscribe({
      next: comment => {
        if (comment) {
          this.echeancesService.rejectDemands([this.demand.demandNumber], 'Motif du rejet : ' + comment).subscribe({
            next: data => {
              if (data?.error) {
                console.error(data.error);
                this.isAlreadyValidating = false;
                this.openErrorSnackBar(
                  data.demandsNumbersInError?.length
                    ? Constants.ErrorMessages.DEMAND_NOT_REJECTED + data.demandsNumbersInError
                    : Constants.ErrorMessages.SERVER_TECH_ERROR
                );
              } else if (data.updatedDemands?.length) {
                this.openSuccessSnackBar(Constants.Messages.DEMAND_REJECTED);
                this.demand.echeances = data.updatedDemands[0].echeances;
                this.echeancesService.checkIfDemandValidableARRejectable(this.demand);
                this.isAlreadyValidating = false;
              }
            },
            error: err => { console.error(err); this.isAlreadyValidating = false; }
          });
        } else {
          this.isAlreadyValidating = false;
        }
      },
      error: err => { console.error(err); }
    });
  }

  public changeDemandEcheanceStatus() {
    this.echeancesService.changeDemandEcheanceStatus(this.demand.demandNumber, this.targetAdminEcheanceStatus).subscribe({
      next: data => {
        if (data?.error) {
          console.error(data.error);
          this.openErrorSnackBar(Constants.ErrorMessages.ECHEANCE_STATUS_NOT_CHANGED);
        } else {
          this.echeancesService.getDemand(this.demand.demandNumber).subscribe({
            next: demandValue => {
              this.isLoading           = false;
              this.demand.echeances    = demandValue.echeances;
              this.isEditingManualData = this.isManualDataNull();
              if (this.demand.echeances) this.demand.echeances.sort(this.compareDues);
              this.refreshTable.emit(true);
            },
            error: err => { this.isLoading = false; throwError('Erreur mise à jour données: ' + err); }
          });
        }
      },
      error: err => { console.error(err); }
    });
  }

  // ── Critères d'affichage ──────────────────────────────────────────────────

  getYearOfDate(date: Date)   { return (date + '').substring(0, 4); }

  getMonthOfDate(date: Date): string {
    const num = +(date + '').substring(5, 7);
    return this.MONTHS[num - 1] + '';
  }

  getDateStatus(date: Date) {
    const year  = parseInt((date + '').substring(0, 4));
    const month = parseInt((date + '').substring(5, 7));
    if (year > this.currPack.packYear)  return 'post';
    if (year < this.currPack.packYear)  return 'past';
    if (month === this.currPack.packMonth) return 'current';
    return month < this.currPack.packMonth ? 'past' : 'post';
  }

  nulldate(date: any) { return date === '0001-01-01'; }

  isValid(date: Date) {
    return date === date && date != null && date.toString() !== '';
  }

  compareDues(ech1: Echeance, ech2: Echeance) {
    if (ech1.date! > ech2.date!) return 1;
    if (ech1.date! < ech2.date!) return -1;
    return 0;
  }

  canBeDeleted() {
    if (!this.authenticationService.isUserAdmin()) return false;
    for (const e of this.demand.echeances) {
      if (!e.projected) return false;
      if (e.status != null && e.status !== EcheanceStatus.DEFAULT) return false;
    }
    return true;
  }

  hasUnknownCommand(d: IDemand) {
    if (!d.reference || d.reference === '') return true;
    const ref = d.reference.toUpperCase();
    if (ref.includes('DEROGATION') || ref.includes('SAUVEGARDE')) return true;
    if (this.orderForms == null) return false;
    for (const of_ of this.orderForms) if (of_.number === d.reference) return false;
    return true;
  }

  isMotifAnnulationObligatoire(): boolean {
  return this.targetStatut === DemandStatut.ANNULE;
}

  getResponsableName() {
    let res = '-';
    try {
      const splitted = (this.demand.responsable + '').split(', ');
      res = splitted[1].split('=')[1] + ' ' + splitted[2].split('=')[1];
    } catch (e) {}
    return res;
  }

  // ── Snackbars ─────────────────────────────────────────────────────────────

  openErrorSnackBar(message: string)   { this.snackbarService.openSnackBar(message, 'error-snack-bar'); }
  openSuccessSnackBar(message: string) { this.snackbarService.openSnackBar(message); }
}